export function excludeProperties<T>(object: T, attributes: readonly string[]) {
    return Object.entries(object as any).reduce((previous, [key, value]) => {
        if (attributes.includes(key)) {
            return previous;
        }

        return { ...previous, [key]: value };
    }, {}) as Omit<T, (typeof attributes)[number]>;
}
